import * as THREE from 'three';

// Loads the night skyline tools/build-skyline.mjs cut into equaliser
// columns - the picture with its windows off, the light every window adds
// (diff), the lossless id map (building, height, kind) and the per-building
// data - once, at startup, for visualizers/skyline.js. Same shape and same
// rule as alley-assets.js / rosace-assets.js: the preload is a WIRING POINT
// every entry point must call; a forgotten one is silent (the getter returns
// null and the city stays dark).
const MANIFEST_URL = 'textures/skyline.json';

let _assets = null;
let _promise = null;

function loadTexture(url, configure) {
  return new Promise(function (resolve, reject) {
    new THREE.TextureLoader().load(url, function (t) { configure(t); t.needsUpdate = true; resolve(t); }, undefined, function () {
      reject(new Error(url + ' failed to load'));
    });
  });
}

// No mipmaps: shown at about its own size; a mip blend over the windows
// lifted the frame against the photograph (see alley-assets.js).
function photo(t) {
  t.colorSpace = THREE.SRGBColorSpace;
  t.generateMipmaps = false;
  t.minFilter = THREE.LinearFilter;
  t.magFilter = THREE.LinearFilter;
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
}

export function preloadSkyline() {
  if (_promise) return _promise;
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('skyline.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (manifest) {
      return Promise.all([
        loadTexture('textures/' + manifest.off, photo),
        loadTexture('textures/' + manifest.diff, photo),
        loadTexture('textures/' + manifest.ids, function (t) {
          t.colorSpace = THREE.NoColorSpace;
          t.generateMipmaps = false;
          t.minFilter = THREE.NearestFilter;
          t.magFilter = THREE.NearestFilter;
          t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
        }),
        fetch('textures/' + manifest.data).then(function (r) {
          if (!r.ok) throw new Error(manifest.data + ' HTTP ' + r.status);
          return r.json();
        })
      ]).then(function (parts) {
        _assets = { manifest: manifest, off: parts[0], diff: parts[1], ids: parts[2], data: parts[3] };
        return _assets;
      });
    })
    .catch(function (err) {
      console.error('[party-mode] skyline assets unavailable, Skyline will stay dark', err);
      _assets = null;
      return null;
    });
  return _promise;
}

export function getSkyline() {
  return _assets;
}

// Node tests only: hand in assets without a fetch.
export function _setSkylineForTests(a) { _assets = a; _promise = Promise.resolve(a); }
